import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a4e95c5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "text-xsm text-weight-medium mb-1"
}
const _hoisted_2 = { class: "flex gap-1" }


export default /*#__PURE__*/_defineComponent({
  __name: 'LevelMeter',
  props: {
	label: {
		type: String,
		required: false,
	},
	numberOfLevels: {
		type: Number,
		default: 3,
	},
	currentLevel: {
		type: Number,
		default: 1,
	},
	position: {
		type: String,
		default: 'right',
		validator(value: string): boolean {
			return ['right', 'left'].includes(value);
		},
	},
	primaryColor: {
		type: String,
		default: '#374151',
	},
	secondaryColor: {
		type: String,
		default: '#9ca3af',
	},
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["level-meter", 'level-meter--align-' + __props.position]),
    style: _normalizeStyle([{ color: __props.primaryColor }])
  }, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(__props.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array.from(Array(__props.numberOfLevels).keys()), (lvl) => {
        return (_openBlock(), _createElementBlock("div", {
          key: lvl,
          class: "level-meter__level-block",
          style: _normalizeStyle([
					lvl + 1 <= __props.currentLevel
						? { 'background-color': __props.primaryColor }
						: { 'background-color': __props.secondaryColor },
				])
        }, null, 4))
      }), 128))
    ])
  ], 6))
}
}

})